<template>
  <div class="container mt-5 login-page" v-on:keyup.13="login()">
    <div class="login-header mt-3 mb-2 animated fadeInDown">
      <div class="text-center">CHARLES & KEITH</div>
    </div>
    <div class="animated fadeInUp">
      <div class="card card-login mx-auto mt-2">
        <!--<div class="card-header text-center"><h4 class="mt-2">Enterprise Portal</h4></div>-->
        <div class="card-body">
          <div class="text-center"><h4 class="mt-2 mb-2 text-white">{{appName}}</h4><span v-if="appSubName" class="env-badge">{{appSubName}}</span></div>
          <form method="post">
            <div class="input-container mt-2">
              <i class="fa fa-user fa-2x icon"></i>
              <input class="input-field" type="text" placeholder="User name" name="username" id="username" required="required" autofocus="autofocus" >
            </div>
            <div class="input-container">
              <i class="fa fa-key fa-2x icon"></i>
              <input class="input-field" type="password" placeholder="Password" name="password" id="password" required="required">
            </div>
            <div class="text-center"><h6 class="mt-2 mb-2 text-white">Please Login With Official Credentials Provided</h6></div>
            <button type="button" class="btn btn-block btn-lg btn-secondary mt-2" @click="login()">Login</button>
          </form>
          <div class="text-center">
            <!--<a class="d-block small mt-3" href="register.html">Register an Account</a>-->
            <!--<a class="d-block mt-3 mb-3 btn-forgot-password text-white" href="#">Forgot Password?</a>-->
          </div>

        </div>
      </div>
      <div class="login-footer mt-2">
        <div class="text-center"><strong>© Charles & Keith Group&nbsp&nbsp;<small>V1.0.0</small></strong></div>
      </div>
    </div>
  </div>
</template>

<style>
  /*body {*/
    /*background: #fff;*/
  /*}*/

  .login-page .card {
    z-index: 5;
  }

  .login-page .card-body {
    background: #000;
    padding: 4px;
    border-radius: 0.5rem;
  }

  .login-page .card-header {
    padding: 2px 4px;
  }

  .login-page .card-footer {
    padding: 2px 4px;
  }

  .login-page .input-container {
    display: -ms-flexbox; /* IE10 */
    display: flex;
    width: 100%;
    margin-bottom: 15px;
    border: 1px gray solid;
    padding-right: 10px;
    border-radius: 0.5rem;
    background: #fff;
  }

  .login-page .input-container .fa {
      color: #000;
    }

  .login-page .input-container input {
    background: #fff;
    border:none;
  }

  .login-page .icon {
    padding: 20px;
    color: #fff;
    min-width: 50px;
    text-align: center;
  }

  .login-page .input-field {
    width: 100%;
    padding: 10px;
    outline: none;
    font-size: 20px;
  }

  .login-page .input-btn {
    font-size: 22px;
    font-weight: 600;
  }

  .login-page .btn-forgot-password {
    font-size: 20px;
  }

  .login-page .input-field:focus {
    border: 2px solid #fff;
  }

  .login-page .bg-dark {
    background-color: #fff !important;
  }

  .login-page .card-login {
    max-width: 25rem;
  }

  .login-page .card-logo {
    margin: 0 20px;
  }

  .login-page .card-logo > img {
    width: 100%;
  }

  .login-page .login-header {
    font-style: "Verdana, Geneva, sans-serif";
    /*background-color: #fff000;*/
    color: #000;
    font-size: 22px;
    letter-spacing: 3px;
  }

  .login-page .login-footer {
    /*background-color: #fff000;*/
    color: #000;
    transition: 0.5s;
    z-index: 4;
  }

</style>

<script>
  import axios from 'axios'
  import {appName, appSubName} from './../../.env.js'

  export default {
    name: 'Login',
    data() {
      return {
//        url: "/api/auth/v1/login/token",
        url: "/user/auth/token",
//        url: "/service/app/auth/ldap",
        method: 'post',
        //url: '/service/app/auth/ldap',
        appName: appName,
        appSubName: appSubName
      }
    },
    mounted() {
      // $('body').css('background', '#fff');
    },
    methods: {
      async login(){
        let username = $("input[name=username]").val();
        let password = $("input[name=password]").val();

        let token = `${username}:${password}`;
        let encodedToken = Buffer.from(token).toString('base64');

        if(username!=''||password!=''){
          let vm = this;
          let timerInterval;
          let loading = true;
          Swal.fire({
            timer: 1000,
            title: 'Verifying User Credentials',
            onBeforeOpen: function () {
              Swal.showLoading();
              timerInterval = setInterval(function () {
                if (loading) {
                  Swal.increaseTimer(1000 - Swal.getTimerLeft());
                }
              }, 100)
            },
            onClose: function () {
              clearInterval(timerInterval)
            }
          });

          try {
            await axios[this.method](this.url, {}, {
              headers: { 'Authorization': 'Basic '+ encodedToken }
            })
              .then(async (response) => {
//                console.log('stifpler', response);
                if(response.status==200 && response.data.code==200) {
                  const genToken = response.data.token
                  //vm.$auth.setToken(response.data.authuser, Date.now());
                  //vm.$auth.setToken(username, response.data[0].object_sid, response.data[0].token, Date.now() + (24 * 60 * 60 * 1000));
                  // vm.$auth.setToken(username, genToken, Date.now() + (24 * 60 * 60 * 1000));
                  vm.$auth.setToken(username, genToken);
                  //vm.$auth.setUser(username, Date.now() + (24 * 60 * 60 * 1000) );
                  // location.reload();
                  //window.location.href = '/';
                  //$('body').css('background', '#EAECEE');
                  //console.log("stifpler", vm.$store.getters.saveModule);
                  if (vm.$store.getters.saveModule){
                    let gotoPage = vm.$store.getters.saveModule;
                    vm.$store.commit('saveModule', '');
                    vm.$router.push(gotoPage);
                  } else {
                    vm.$router.push('/');
                  }
                  // location.reload();

                  // let redirectFromUrl = vm.$route.query.redirect;
                  //
                  // if (redirectFromUrl) {
                  //   vm.$router.push(redirectFromUrl);
                  // } else {
                  //   vm.$router.push('/');
                  // }
                } else {
                  Swal.fire({
                    timer: 5000,
                    type: 'error',
                    title: response.data.code,
                    text: response.data.message
                  });
                }
                loading = false;
              })
              .catch((error) => {
                console.log(error);
                loading = false;
                let message = 'Access Denied!';
                if (error && error.response && error.response.data) {
                  if (typeof error.response.data === 'string') message = error.response.data;
                  else if (error.response.data.error) message = error.response.data.error;
                  else if (error.response.data.msg) message = error.response.data.msg;
                }
                Swal.fire({
                  timer: 3000,
                  type: 'error',
                  title: "Access Failed!",
                  text: message
                });
              });
          } catch (err) {
            //alert(err.message);
            Swal.fire({
              timer: 3000,
              type: 'error',
              title: "",
              text: err.message
            });
          }
        } else {
          Swal.fire({
            timer: 5000,
            type: 'error',
            title: 'Please Enter Username and Password'
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/Login.vue